/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lp_Welcome_Landing_Operationsdescription2Inputs */

const en_coinvestments_lp_welcome_landing_operationsdescription2 = /** @type {(inputs: Coinvestments_Lp_Welcome_Landing_Operationsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your allocation and track the progress of your co-investments in one place`)
};

/**
* | output |
* | --- |
* | "Manage your allocation and track the progress of your co-investments in one place" |
*
* @param {Coinvestments_Lp_Welcome_Landing_Operationsdescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lp_welcome_landing_operationsdescription2 = /** @type {((inputs?: Coinvestments_Lp_Welcome_Landing_Operationsdescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lp_Welcome_Landing_Operationsdescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lp_welcome_landing_operationsdescription2(inputs)
});
export { coinvestments_lp_welcome_landing_operationsdescription2 as "coInvestments_lp_welcome_landing_operationsDescription" }